export default [
  [[1, 4], [2, 3]],
  [[4, 2], [1, 3]],
  [[3, 4], [2, 1]]
];
